export default {"src":"/_next/static/media/EquationDAO.c4bb49cb.svg","height":30,"width":153,"blurWidth":0,"blurHeight":0};